import { render } from "./EditChecklistItem.vue?vue&type=template&id=559f83e8"
import script from "./EditChecklistItem.vue?vue&type=script&lang=js"
export * from "./EditChecklistItem.vue?vue&type=script&lang=js"
script.render = render

export default script